var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.data != undefined && _vm.params.data.hasDuplicate.length != 0)?_c('router-link',{attrs:{"target":"_blank","to":{ name: 'resolveduplicate', params: { id: _vm.params.data.id } }}},[_c('i',{staticClass:"fa fa-link",staticStyle:{"color":"red","cursor":"pointer"},attrs:{"aria-hidden":"true"}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }